import {
  uninitializedRemoteData,
  fetchedRemoteData,
  RemoteData,
} from '@/lib/frontend/store/helpers/remoteData';
import { Action } from '../../actions';
export type Validators = {
  maximumSurveyResponseLength: RemoteData<number>;
};
const defaultState = {
  maximumSurveyResponseLength: uninitializedRemoteData<number>(),
};
export default function validatorsReducer(
  state: Validators = defaultState,
  action: Action,
): Validators {
  switch (action.type) {
    case 'FETCH_SHOP_INFO_SUCCESS':
      return Object.assign({}, state, {
        maximumSurveyResponseLength: fetchedRemoteData(
          action.updatedShopInfo.MaximumSurveyResponseLength,
        ),
      });
    default:
      return state;
  }
}
